<a *ngIf="item" [routerLink]="item.system_name">
    <div class="container" matRipple matRippleColor="rgba(27, 141, 120, 0.5)">
        <!-- <img [src]="images[index].image" [attr.aria-label]="'image of ' + item.title"> -->
        <img [src]="safeResourceUrl" [attr.aria-label]="'image of ' + item.title">
        <div class="shadow"></div>
        <!-- <p>{{getSystem(item?.title)}}</p> -->
        <p>{{'SYSTEM.' + item.system_name | translate}}</p>

        <!-- <p>{{ 'SYSTEM.RESORT' | translate: { resort: ('SYSTEM.' + item.id | translate) } }}</p> -->
        <!-- <p>{{ lang == 'en' ? item.title_en : item.title_kh }}</p> -->
    </div>
</a>
<!-- [style.backgroundImage]="'url(' + item.image + ')'" -->